import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_bar = _resolveComponent("menu-bar")!
  const _component_editor_content = _resolveComponent("editor-content")!

  return ($data.editor)
    ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 0 }, $options.setId, { class: "richText" }), [
        _createVNode(_component_menu_bar, {
          class: "richText__header",
          editor: $data.editor
        }, null, 8, ["editor"]),
        _createVNode(_component_editor_content, {
          class: "richText__content",
          editor: $data.editor,
          "data-cy": $props.editorContentDataCy
        }, null, 8, ["editor", "data-cy"])
      ], 16))
    : _createCommentVNode("", true)
}